var _g, _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 47,
    viewBox: "0 0 70 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3522_3546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9227 16C20.0724 16 21.717 16.6194 22.4323 17.5731V27.4998C19.2852 29.2164 14.9235 29.5896 13.8494 28.8744C12.7752 28.1593 9.77295 16 14.9227 16Z",
    fill: "#255986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.876 32.0932L22.4321 27.4441V17.4307C25.8653 16.2863 30.419 16.9539 32.0879 17.4307C33.9952 18.0267 38.7396 19.5049 42.4589 20.6493C44.7191 21.1709 45.0005 22.5 44.5437 22.7004C44.0005 23 43.6886 23.5873 43.1741 23.8679L50.3265 22.795C58.6233 21.6506 58.3134 23.9871 57.1213 25.2984C54.1412 27.0865 47.0364 30.9488 42.4589 32.0932C37.8813 33.2376 34.8296 32.57 33.876 32.0932Z",
    fill: "#255986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 22.5C44.5 23.5 37.3078 26.0851 31.0137 23.5103",
    stroke: "#EFF3F6",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_3522_3546",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 0H39V5H34V11H39V16H45V11H50V5H45V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 0H39V5H34V11H39V16H45V11H50V5H45V0Z",
    fill: "#64C1B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0V-1H38V0H39ZM45 0H46V-1H45V0ZM39 5V6H40V5H39ZM34 5V4H33V5H34ZM34 11H33V12H34V11ZM39 11H40V10H39V11ZM39 16H38V17H39V16ZM45 16V17H46V16H45ZM45 11V10H44V11H45ZM50 11V12H51V11H50ZM50 5H51V4H50V5ZM45 5H44V6H45V5ZM39 1H45V-1H39V1ZM40 5V0H38V5H40ZM34 6H39V4H34V6ZM35 11V5H33V11H35ZM39 10H34V12H39V10ZM40 16V11H38V16H40ZM45 15H39V17H45V15ZM44 11V16H46V11H44ZM50 10H45V12H50V10ZM49 5V11H51V5H49ZM45 6H50V4H45V6ZM44 0V5H46V0H44Z",
    fill: "#64C1B4",
    mask: "url(#path-4-inside-1_3522_3546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3522_3546",
    x: 0,
    y: 6,
    width: 69.7478,
    height: 40.7251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.34902 0 0 0 0 0.52549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3522_3546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3522_3546",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatments);
export default __webpack_public_path__ + "static/media/treatments.be20ffe8e35264a4c226e0cfe3c80b34.svg";
export { ForwardRef as ReactComponent };